module.exports = __webpack_public_path__ + "img/accueil-continuer.62ec70ea.png";